"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHomeBannerApiClient = createHomeBannerApiClient;
const index_const_1 = require("../index.const");
const axios_client_1 = require("@invivodf/axios-client");
const infra_1 = require("../infra");
function createHomeBannerApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function findByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/home-banner`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function createOrUpdateHomeBanner(partnerId, homeBanner) {
        try {
            const response = await client.post(`/v1/partners/${partnerId}/home-banner`, homeBanner);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        findByPartnerId,
        createOrUpdateHomeBanner,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9tZS1iYW5uZXIuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvbWUtYmFubmVyL2hvbWUtYmFubmVyLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVVBLDhEQTZCQztBQXRDRCxnREFBMkM7QUFDM0MseURBQThFO0FBQzlFLG9DQUFzQztBQU90QyxTQUFnQix5QkFBeUIsQ0FBQyxPQUFlLEVBQUUsT0FBMkI7SUFDcEYsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sSUFBSSx5QkFBVyxDQUFBO0lBRTVDLE1BQU0sTUFBTSxHQUFHLElBQUEsZ0NBQWlCLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBRWxELEtBQUssVUFBVSxlQUFlLENBQUMsU0FBaUI7UUFDOUMsSUFBSSxDQUFDO1lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxNQUFNLENBQUMsR0FBRyxDQUFnQixnQkFBZ0IsU0FBUyxjQUFjLENBQUMsQ0FBQTtZQUN6RixPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUE7UUFDdEIsQ0FBQztRQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7WUFDYixJQUFJLEdBQUcsWUFBWSxLQUFLO2dCQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUN2RCxJQUFBLG1CQUFXLEVBQUMsR0FBRyxDQUFDLENBQUE7UUFDbEIsQ0FBQztJQUNILENBQUM7SUFFRCxLQUFLLFVBQVUsd0JBQXdCLENBQUMsU0FBaUIsRUFBRSxVQUF5QjtRQUNsRixJQUFJLENBQUM7WUFDSCxNQUFNLFFBQVEsR0FBRyxNQUFNLE1BQU0sQ0FBQyxJQUFJLENBQWdCLGdCQUFnQixTQUFTLGNBQWMsRUFBRSxVQUFVLENBQUMsQ0FBQTtZQUN0RyxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUE7UUFDdEIsQ0FBQztRQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7WUFDYixJQUFJLEdBQUcsWUFBWSxLQUFLO2dCQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUN2RCxJQUFBLG1CQUFXLEVBQUMsR0FBRyxDQUFDLENBQUE7UUFDbEIsQ0FBQztJQUNILENBQUM7SUFFRCxPQUFPO1FBQ0wsZUFBZTtRQUNmLHdCQUF3QjtLQUN6QixDQUFBO0FBQ0gsQ0FBQyJ9